import { itemDepartmentSelectors } from "Redux/Selectors";

const initialState = {
  loading: false,
  rows: [],
};

export const itemDepartmentReducer = (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case itemDepartmentSelectors.GET_ITEM_DEPARTMENT:
      return {
        ...state,
        loading: true,
      };

    case itemDepartmentSelectors.GET_ITEM_DEPARTMENT_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
